/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Keyword_Optimizer_Coverage_TotalInputs */

const en_keyword_optimizer_coverage_total = /** @type {(inputs: Keyword_Optimizer_Coverage_TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`total keywords`)
};

const de_keyword_optimizer_coverage_total = /** @type {(inputs: Keyword_Optimizer_Coverage_TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`total keywords`)
};

const fr_keyword_optimizer_coverage_total = /** @type {(inputs: Keyword_Optimizer_Coverage_TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`total keywords`)
};

const es_keyword_optimizer_coverage_total = /** @type {(inputs: Keyword_Optimizer_Coverage_TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`total keywords`)
};

const it_keyword_optimizer_coverage_total = /** @type {(inputs: Keyword_Optimizer_Coverage_TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`total keywords`)
};

const nl_keyword_optimizer_coverage_total = /** @type {(inputs: Keyword_Optimizer_Coverage_TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`total keywords`)
};

const pl_keyword_optimizer_coverage_total = /** @type {(inputs: Keyword_Optimizer_Coverage_TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`total keywords`)
};

const fi_keyword_optimizer_coverage_total = /** @type {(inputs: Keyword_Optimizer_Coverage_TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`total keywords`)
};

const da_keyword_optimizer_coverage_total = /** @type {(inputs: Keyword_Optimizer_Coverage_TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`total keywords`)
};

const sv_keyword_optimizer_coverage_total = /** @type {(inputs: Keyword_Optimizer_Coverage_TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`total keywords`)
};

/**
* | output |
* | --- |
* | "total keywords" |
*
* @param {Keyword_Optimizer_Coverage_TotalInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const keyword_optimizer_coverage_total = /** @type {((inputs?: Keyword_Optimizer_Coverage_TotalInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Keyword_Optimizer_Coverage_TotalInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_keyword_optimizer_coverage_total(inputs)
	if (locale === "fr") return fr_keyword_optimizer_coverage_total(inputs)
	if (locale === "es") return es_keyword_optimizer_coverage_total(inputs)
	if (locale === "it") return it_keyword_optimizer_coverage_total(inputs)
	if (locale === "nl") return nl_keyword_optimizer_coverage_total(inputs)
	if (locale === "pl") return pl_keyword_optimizer_coverage_total(inputs)
	if (locale === "fi") return fi_keyword_optimizer_coverage_total(inputs)
	if (locale === "da") return da_keyword_optimizer_coverage_total(inputs)
	if (locale === "sv") return sv_keyword_optimizer_coverage_total(inputs)
	return en_keyword_optimizer_coverage_total(inputs)
});